import http from '@/http'

const URL = '/admin/thank-you-pages'

export default {
  /**
   * Listar todas as páginas de obrigado
   */
  list (params = {}) {
    return http.get(URL, { params })
  },

  /**
   * Listar páginas ativas (para dropdown)
   */
  listActive () {
    return http.get(`${URL}/active`)
  },

  /**
   * Obter página padrão
   */
  getDefault () {
    return http.get(`${URL}/default`)
  },

  /**
   * Obter página específica
   */
  show (id) {
    return http.get(`${URL}/${id}`)
  },

  /**
   * Criar nova página
   */
  create (data) {
    return http.post(URL, data)
  },

  /**
   * Atualizar página
   */
  update (id, data) {
    return http.put(`${URL}/${id}`, data)
  },

  /**
   * Deletar página
   */
  delete (id) {
    return http.delete(`${URL}/${id}`)
  },

  /**
   * Alterar status
   */
  changeStatus (id) {
    return http.put(`${URL}/${id}/status`)
  },

  /**
   * Definir como padrão
   */
  setAsDefault (id) {
    return http.put(`${URL}/${id}/set-default`)
  }
}
